import { useRef, useEffect, MutableRefObject } from "react";

export const useInitScrollRef = (
  element: HTMLDivElement | null,
  invert = false
): MutableRefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement | null>(element);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = invert ? -1 : 1;
      ref.current.scrollTop = 0;
      ref.current.scrollLeft = invert ? -1 : 1;
      ref.current.scrollLeft = 0;
    }
  }, [invert]);

  return ref;
};
